import { useQueryClient } from '@tanstack/react-query'

export function useInvalidatePokemon() {
  const queryClient = useQueryClient()

  return {
    invalidateAll: () => queryClient.invalidateQueries({ queryKey: ['pokemon'] }),
    invalidateList: () => queryClient.invalidateQueries({ queryKey: ['pokemon', 'list'] }),
    invalidateDetail: (name: string) =>
      queryClient.invalidateQueries({ queryKey: ['pokemon', 'detail', name] }),
  }
}

export function usePrefetchPokemon() {
  const queryClient = useQueryClient()
  const POKEMON_PER_PAGE = 5

  return {
    prefetchNextPage: async (page: number) => {
      const offset = page * POKEMON_PER_PAGE
      await queryClient.prefetchQuery({
        queryKey: ['pokemon', 'list', page + 1],
        queryFn: async () => {
          const response = await fetch(
            `https://pokeapi.co/api/v2/pokemon?limit=${POKEMON_PER_PAGE}&offset=${offset}`
          )
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        },
      })
    },
    prefetchDetail: async (name: string) => {
      await queryClient.prefetchQuery({
        queryKey: ['pokemon', 'detail', name],
        queryFn: async () => {
          const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${name}`)
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        },
      })
    }
  }
} 
